import { useEffect } from 'react';
import { scrollTo } from '@utils/scroll';

import { page } from '@v2/services/analytics.service';

import CartBoxes from '@pages/cart/cart-boxes';
import CartOrder from '@pages/cart/cart-order';

import v2WrapperStyles from '@styles/wrapper';
import styles from '@components/pages/cart/cart.styles';
import { CART_FORM_KEY } from './hooks';
import { useInitCartForm } from '@v2/hooks/form';

export default function CartPage() {
    // const dispatch = useDispatch();

    // const cart = useCart();
    // const isLogged = useIsLogged();
    // const initialLoggedUser = useSubscriberCheckoutUser();
    // const noShipping = useAddingToSubscription();

    useInitCartForm(CART_FORM_KEY, { orderType: 'add-to' });

    useEffect(() => {
        page('Cart');
        // removed init checkout
        scrollTo('root', 0);
    }, []);

    return (
        <div className={`${v2WrapperStyles.v2Global} ${styles.pageContainer}`}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-md-8">
                        <CartBoxes />
                    </div>
                    <div className="col-12 col-md-4 custom-column">
                        <CartOrder />
                    </div>
                </div>
            </div>
        </div>
    )
}